import { useState } from 'react';
import { usePortfolioContext, useProjectContext } from '~/hooks';
import UpdateProjectNameModal from '~/modals/UpdateProjectNameModal';
import { Icon } from 'semantic-ui-react';
import UpdatePortfolioNameModal from '~/modals/UpdatePortfolioNameModal';
import { Button } from 'semantic-ui-react';
import { usePermissions } from '~/requests/permissions/usePermissions';
import './styles.scss';

interface Props {
  type: 'project' | 'portfolio' | 'portfolioProject'
  allowEdits?: boolean
  editButtonDisabled?: boolean
}

export default function EditableName({ type, editButtonDisabled = false, allowEdits = true }: Props) {
  // Get project/portfolio from context
  const { project } = useProjectContext();
  const { portfolio } = usePortfolioContext();
  const { permissions } = usePermissions();

  // Determine if data is loaded
  const dataLoaded = !!project?.id || !!portfolio?.id;

  // Track modal visibility
  const [showModal, setShowModal] = useState(false);

  // Derive booleans based on type prop
  const isProject = type === 'project' || type === 'portfolioProject';
  const isPortfolio = type === 'portfolio';

  // Derive name and status: 'in review', 'bidding', 'bid review'
  const name = isProject ? project?.name : portfolio?.name;

  return (
    <div className="editable-name-container">
      {dataLoaded && (
        <h1>{name}</h1>
      )}
      {allowEdits && permissions.hasProjectDeveloperAccess && (
        <Button className="editable-name-button" disabled={editButtonDisabled} size="tiny" aria-label={`Edit ${type}`} onClick={() => setShowModal(true)}>
          <Icon name="pencil" />
        </Button>
      )}

      {/* Modals */}
      {showModal && isProject && <UpdateProjectNameModal closeModal={() => setShowModal(false)} />}
      {showModal && isPortfolio && <UpdatePortfolioNameModal closeModal={(() => setShowModal(false))} />}
    </div>
  );
}